import {
  type DatabaseField,
  DatabaseFieldType,
  type DatabaseValue,
  type SelectOption,
} from '@databases/types/database';

import { DatabaseGroup } from './database-group';

export class DatabaseGroupSelectField extends DatabaseGroup<DatabaseFieldType.SELECT> {
  get fieldSelectOptions(): SelectOption[] {
    return this.groupField.settings.selectOptions;
  }

  get selectOption(): SelectOption | undefined {
    return this.fieldSelectOptions.find(
      (option) => option.id === this.key || option.label === this.key
    );
  }

  override get displayValue(): string | undefined {
    return this.selectOption?.label;
  }

  static generateKeyForFieldValue(
    fieldValue: DatabaseValue<DatabaseFieldType.SELECT>
  ): string {
    // key = select option ID
    return fieldValue.value[0];
  }

  static createFromSelectOption(
    option: SelectOption,
    groupField: DatabaseField<DatabaseFieldType.SELECT>
  ) {
    const optionId = option.id ?? option.label;
    return new DatabaseGroupSelectField(optionId, groupField, {
      type: DatabaseFieldType.SELECT,
      value: [optionId],
    });
  }
}
